import { Component, inject } from '@angular/core';
import { first } from 'rxjs';
import { FeatureActivatedGuardWrapper } from '../../../../guards/feature-activated/feature-activated.guard';
import { PunchoutAuditOrderRequestListConfigService } from '../../../../services/punchout-audit-order-request-list-config.service';
import { PunchoutAuditTabBase } from '../punchout-audit-tab.base';

/**
 * Order requests tab: purchase orders delivered to the public cXML intake endpoint.
 *
 * Receiving these does not need the EDI module, but processing them does. An app without EDI
 * accumulates RECEIVED entries that nothing will process. The banner states this, instead of
 * leaving an admin to wonder why the queue never drains.
 */
@Component({
  selector: 'lib-gung-settings-punchout-order-requests',
  templateUrl: './gung-settings-punchout-order-requests.component.html',
  styleUrl: './gung-settings-punchout-order-requests.component.scss',
  standalone: false
})
export class GungSettingsPunchoutOrderRequestsComponent extends PunchoutAuditTabBase {
  protected featureGuard = inject(FeatureActivatedGuardWrapper);
  public readonly config = inject(PunchoutAuditOrderRequestListConfigService);

  ediEnabled = true;

  constructor() {
    super();
    this.featureGuard
      .isActivated('gung-feature-edi', '1.0.0', true)
      .pipe(first())
      .subscribe(activated => (this.ediEnabled = activated));
  }
}
